<app-date-picker [value]="value" [date]="value" (valueChange)="onValueChange($event)"></app-date-picker>
